import React, { memo } from 'react';
import Link from 'next/link';
import Tab from '@ertelecom/ui-react/components/tabs/tab';
import * as S from '../styled';
import * as ST from './styled';
import { sectionData } from './section-data';

const renderList = () => (
    sectionData.map(({ id, label, title, text, src, href, hrefText }) => (
        <Tab label={label} key={id}>
            <ST.TabContent>
                <ST.TabTitle>{title}</ST.TabTitle>
                <ST.TabImgWrap>
                    <ST.Img src={`/static/images/domru-tv/look/${src}`} alt='' />
                </ST.TabImgWrap>
                <ST.TabText>{text}</ST.TabText>
                <Link href={href} passHref prefetch={false}>
                    <ST.TabLink>{hrefText}</ST.TabLink>
                </Link>
            </ST.TabContent>
        </Tab>
    ))
);

const WatchComfort = () => (
    <ST.Section bgColor='#fff'>
        <S.InnerContainer>
            <S.SectionTitle>Смотрите как удобно</S.SectionTitle>
            <S.STabs withSSR>
                {renderList()}
            </S.STabs>
        </S.InnerContainer>
    </ST.Section>
);

export default memo(WatchComfort);
